import { React, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
     addMonthsToDateString,
      getFormattedDate,isEndDateGreater,changeDateFormat,getMonthRange
  } from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import axios from 'axios';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {getGroupSubGroupExcleReport}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';


function UrbanEastIndexReport() {

    const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState('');
    const [reportType, setReportType] = useState('');
    const storedLanguage = localStorage.getItem('language');
    const today = new Date();
    const config = getAuthHeaders();

 
  
// Handle on change Event ********
const handleDropdownChange = (e) => {

    setStartDate(e);
     const currentDate=getFormattedDate(e)
   if(reportType==='1'){ //Monthly
       let stringData=addMonthsToDateString(currentDate,0);
       let date= stringData[0] + stringData.slice(1).toLocaleLowerCase()
       setEndDate(date);
     }else{ //Quarterly
       let stringData=addMonthsToDateString(currentDate,2);
       let date= stringData[0] + stringData.slice(1).toLocaleLowerCase()
       setEndDate(date);
     }
   
   };


const handleReportTypeChange=(e)=>{
    setReportType(e.target.value)
    setStartDate(null);
    setEndDate('');

}
   
   
   
   //handle excel sheet ***************
const handleGenerateExcel = async() => {

        if(reportType===''){
        toast.error('Please select Report Type', messages.COLOR_RED);
            return
        }
        if (!startDate || !endDate) {
            toast.error('Please select the date range', messages.COLOR_RED);
            return;
        }

        if(!isEndDateGreater(startDate,endDate)){
        toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
        return;
        }

        let sDate= getFormattedDate(startDate);
        let eDate=  endDate[0] + endDate.slice(1).toLocaleUpperCase();

    try {
    showLoading(true);

        let post_data={
            fromDate: sDate,
          toDate:eDate,
           reportType: reportType
        }

        const response = await axios.post(`${API_URL}api/price/getUrbanEastRegionIndex`, post_data, config);
        const reportData = response.data;
        if(reportData.status){
            let allData= reportData.data[0].GroupCodes;
            const mappedData = [];
            if (allData && allData.length > 0) {

           const lastItem = allData[allData.length - 1];
           const newItems = [lastItem, ...allData.slice(0, -1)];
          newItems.forEach(group => {
                  // Add group data
                  mappedData.push({
                    majorGroupHindiName: group.majorGroupHindiName,
                    region_Weight: group.region_Weight,
                    region_index1: group.region_index1,
                    region_index2: group.region_index2,
                    region_index3: group.region_index3,
                    avgRegionIndex:group.avgRegionIndex,
                    MAJOR_GROUP_NAME:group.MAJOR_GROUP_NAME,
                  });
            
                  group.subGroups.forEach(subGroup => {
                    // Add subgroup data
                    mappedData.push({
                        subGroupHindiName: subGroup.subGroupHindiName,
                        region_Weight: subGroup.region_Weight,
                        region_index1: subGroup.region_index1,
                        region_index2: subGroup.region_index2,
                        region_index3: subGroup.region_index3,
                        avgRegionIndex:subGroup.avgRegionIndex,
                        SUB_GROUP_NAME:subGroup.SUB_GROUP_NAME,
                     });
            
                    subGroup.itemCodes.forEach(item => {
                      // Add item data
                      mappedData.push({
                        itemHindiName: item.itemHindiName,
                        region_Weight: item.region_Weight,
                        region_index1: item.region_index1,
                        region_index2: item.region_index2,
                        region_index3: item.region_index3 || '',
                        avgRegionIndex:item.avgRegionIndex,
                        itemName:item.itemName,
                      });
                    });
                  });
                });
             }


           downloadReport(mappedData,reportType,sDate,eDate)

        }else{
          toast.error('Data is not found', messages.COLOR_RED);
       
        }

    } catch (error) {
    console.error(error);

    }finally{
    showLoading(false);
    }
   }


const getSheetColumnData=(item)=>{
    let data='';

    if(reportType==='1'){ // Monthly
    data= [(parseFloat(item.region_Weight) || 0).toFixed(2),
           (parseFloat(item.region_index1) || 0).toFixed(2),
            (parseFloat(item.avgRegionIndex) || 0).toFixed(2)]
    }
        
  if(reportType==='2'){ // Quarterly
        data=  [(parseFloat(item.region_Weight) || 0).toFixed(2),
                (parseFloat(item.region_index1) || 0).toFixed(2),
                (parseFloat(item.region_index2) || 0).toFixed(2),
                (parseFloat(item.region_index3) || 0).toFixed(2),
                (parseFloat(item.avgRegionIndex) || 0).toFixed(2)]
    }

    return data;
 }

   
   
   
   const downloadReport=(allData,report,sDate,eDate)=>{

            let reportName = report === '1' ?"Monthly": "Quarterly" ;
            let bothDate = report === '1' ? `${sDate}`: `${sDate}-${eDate}`;
            let dateArray=sDate;
            let headerYearColumns=['','',sDate,'',''];
            let headerColumns=['मद','भार','सूचकांक  Index','औसत', 'Item']
            if(report==='2'){ //Quarterly
                dateArray=getMonthRange(sDate,2)
                headerYearColumns=['','',...dateArray,'',''];
                headerColumns=['मद','भार','सूचकांक  Index','','','औसत', 'Item']
            }


            const transformedData = [];

            allData.forEach(item => {
              if (item.majorGroupHindiName) {
                transformedData.push([
                  item.majorGroupHindiName,
                 ...getSheetColumnData(item),
                  item.MAJOR_GROUP_NAME
                
                ]);
              }
        
              if (item.subGroupHindiName) {
                transformedData.push([
                    item.subGroupHindiName,
                    ...getSheetColumnData(item),
                   item.SUB_GROUP_NAME
        
                ]);
              }
        
              if ( item.itemName) {
                transformedData.push([
                    item.itemHindiName,
                    ...getSheetColumnData(item),
                   item.itemName
        
                ]);
              }
            });

            let redGroup = ['समस्त','खाद्य, पेय द्रव्य और तम्बाकू','अनाज और उत्पाद', 'दालें एवं उत्पाद', 'दूध एवं दूग्ध उत्पाद',
              'तेल व स्निग्ध पदार्थ','माँस, मछली व अण्डा','तरकारी','फल एवं शुष्क फल','चीनी, गुड़ आदि','मसाले','तैयार भोजन और अल्पाहार','अमादक पेय',
            'पान,   सुपारी, तम्बाकू व मादक पेय','ईंधन व प्रकाश','आवास','वस्त्र, बिस्तर एवं जूते','वस्त्र और बिस्तर',
            'जूते','विविध','शिक्षा','चिकित्सा','मनोरंजन आदि','व्यक्तिगत देख-रेख एवं चल सम्पत्ति','घरेलू और आवश्यकताएं',
            'यातायात और संचार','अन्य ' ,'खाद्य पेय पदार्थ और तंबाकू', 'दालें और उत्पाद','दूध और दूध उत्पाद','तेल और वसा','मीट मछली और अंडे',
            'सब्जियां','फल और सूखे फल','चीनी और गुरु आदि','मसालों और मसालों','तैयार भोजन और ताज़ा करना','गैर शराब पेय पदार्थ',
            'पैन सुपारी और तंबाकू पेय पदार्थ','ईंधन और प्रकाश','वस्त्र बिस्तर और जूते','कपड़े और बिस्तर','कई तरह का','चिकित्सा देखभाल',
            'मनोरंजन और मनोरंजन','व्यक्तिगत देखभाल और प्रभाव','परिवहन और संचार','अन्य लोग'];

            const excelObjectData = {
            report:report,  
            fileName:`UrbanPriceIndexOfEasternRegion_${reportName} (${bothDate})`,
            fileType:'xls',
            sheetName: 'UrbanPriceIndexOfEasternRegion',
            firstRowMergeCells: (report==='1') ?'A1:E1' : 'A1:G1',
            firstRowExportDate:  changeDateFormat(new Date()),
            secondRowMergeCells: (report==='1') ?'A2:E2' : 'A2:G2',
            secondRowText: `पूर्वी क्षेत्र को नगरीय उपभोक्ता भाव सूचकांक (आधार कृषि वर्ष 2011-12=100)`,
            thirdRowMergeCells: (report==='1') ?'A3:E3' : 'A3:G3',
            thirdRowText: ` URBAN CONSUMER PRICE INDEX OF EASTERN REGION (${bothDate})  (Base Agr. Year 2011-12=100)`,
            headerEnglishColumns:headerColumns,
            headerYearColumns: headerYearColumns,
            excelRowData:transformedData,
            redGroup:redGroup

            };

        excelObjectData.excelRowData = transformedData;
        getGroupSubGroupExcleReport(excelObjectData);
    }
   
     return (
       <>
           <ToastContainer />
           <GlobalLoading />
           <div className="container-fluid py-3">
               <div className="card mx-3 mb-3">
                   <div className="card-body pb-1">
                       <div className="row align-items-center">
                           <h4 className="page_heading">
                               <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.URBAN_EAST_INDEX_REPORT : priceTitle.en.URBAN_EAST_INDEX_REPORT }} />
                           </h4>
                           <div className="row align-items-center">
                               
                           <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                               <label> Select Report Type</label>
   
                               <select  
                               name="report_type" 
                               className="form-select"
                               onChange={handleReportTypeChange}
                               value={reportType}
                               >
                               <option value="" disabled>[---Select--]</option>
                               <option value="1">Monthly</option>
                               <option value="2">Quarterly</option>
                             </select>
   
                           </div>
   
   
                           <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                               <label className="fw-bold h6">From Date</label>
                               <DatePicker
                                   className="form-control calendar_icon"
                                   selected={startDate}
                                   onChange={handleDropdownChange}
                                   dateFormat="MMM yyyy"
                                   showMonthYearPicker
                                   placeholderText="Select month"
                                   name="startDate"
                                   maxDate={today}
                               />
                           </div>
   
   
                           <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                               <label className="fw-bold h6">To Date</label>
   
                               <input 
                               className="form-control"
                               type="text" 
                               name="endDate"
                               value={endDate}
                               readOnly
                               />
                           </div>
   
   
                           <div className="col-xl-2 col-lg-4 mb-3">
                               <label className="w-100 d-none d-sm-block">&nbsp;</label>
                               <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                           </div>
                           </div>
   
   
                       </div>
                   </div>
               </div>
           </div>
      </>
     )
   }
   
   export default UrbanEastIndexReport